module.exports = __webpack_public_path__ + "static/media/card7.29df9a18.jpg";